import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Progress } from "reactstrap";
import back from "../assets/back.png";
import Api from "./api/api";
import MyLoader from "./util/loader";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import captureVideoFrame from "capture-video-frame";
import CustomPicker from "./util/custom_picker";
import Axios from "axios";
import { v4 as uuidv4 } from "uuid";
import GLOBAL from "../global";

var files = [];

const UploadVideos = () => {
  const location = useLocation();
  const model = location.state.model;
  const guide = location.state.guide;
  const settings_pro = location.state.settings_pro;
  const library_type = location.state.type;
  var history = useHistory();

  console.log("library_type: " + library_type);

  const [videoUrl, setVideoUrl] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [selectedVideos, setSelectedVideos] = useState([]);

  const [videosCount, setVideosCount] = useState(0);
  const [index, setVideoIndex] = useState(0);
  const [uploading, setUploading] = useState(false);

  const [loader, setLoader] = useState(false);
  const addFile = useRef(null);

  // ! ==============================================================
  const [uploadId, setUploadId] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileToBeUpload, setFileToBeUpload] = useState({});
  const [progress, setProgress] = useState([]);
  const [fileSize, setFileSize] = useState(0);
  const [urls, setUrls] = useState([]);
  const [parts, setParts] = useState([]);
  const [chunkCount, setChunkCount] = useState(0);

  async function initiateMultipartUpload(_fileName) {
    const response = await Api.createMultipartUpload(_fileName).catch(
      (error) => {
        showToast("error initiateMultipartUpload!", error);
      }
    );

    if (response.status === 200) {
      setUploadId(response.data.uploadId);
    } else {
      showToast("error initiateMultipartUpload");
    }
  }

  async function generatePresignedUrlsParts() {
    const promises = [];

    for (let index = 0; index < chunkCount; index++) {
      promises.push(Api.signPartUpload(fileName, uploadId, index + 1));
    }

    const res = await Promise.all(promises);

    console.log("Promise.all: ", res);

    const _urls = {};
    for (let i = 0; i < res.length; i++) {
      const part = res[i];
      _urls[i] = part.data.url;
    }
    setUrls(_urls);
  }

  const FILE_CHUNK_SIZE = 50 * 1048576;

  async function uploadParts() {
    const axios = Axios.create();
    delete axios.defaults.headers.put["Content-Type"];

    const keys = Object.keys(urls);
    const promises = [];

    for (const indexStr of keys) {
      const index = parseInt(indexStr);
      const start = index * FILE_CHUNK_SIZE;
      const end = (index + 1) * FILE_CHUNK_SIZE;
      const blob =
        index < keys.length
          ? fileToBeUpload.slice(start, end)
          : fileToBeUpload.slice(start);

      promises.push(
        axios.put(urls[index], blob).then((r) => {
          setProgress((p) => [...p, 1]);
          return r;
        })
      );
    }

    const resParts = await Promise.all(promises);
    console.log("resParts", resParts);

    setParts(
      resParts.map((part, index) => ({
        ETag: part.headers.etag,
        PartNumber: index + 1,
      }))
    );
  }

  async function completeMultiUpload() {
    Api.completeMultipartUpload(
      fileName,
      uploadId,
      parts,
      (response) => {
        console.log("completeMultiUpload response", response);
        let id = "" + randomFixedNumber(6);

        const _fileName = fileName
          .replace(".mov", ".mp4")
          .replace(".mp4", "/index.m3u8");

        if (model == null && !guide && settings_pro) {
          console.log("file uploaded: " + _fileName);
          GLOBAL.tempUploadedProVideoName = _fileName;
          history.goBack();
        } else if (model == null && guide) {
          Api.addGuideVideo(
            fileToBeUpload.name,
            thumbnail,
            _fileName,
            (response) => {
              if (response.status === "success") {
                // upload next video
                let i = index + 1;
                setVideoIndex(i);
                uploadVideo(i);
              } else {
                showToast("error", "Upload Failed!");
                setUploading(false);
                setVideoIndex(0);
              }
            },
            () => {
              showToast("error", "Upload Failed!");
              setUploading(false);
              setVideoIndex(0);
            }
          );
        } else {
          Api.addCategoryVideo(
            library_type,
            id,
            model.id,
            fileToBeUpload.name,
            thumbnail,
            _fileName,
            (response) => {
              if (response.status === "success") {
                // upload next video
                let i = index + 1;
                setVideoIndex(i);
                uploadVideo(i);
              } else {
                showToast("error", "Upload Failed!");
                setUploading(false);
                setVideoIndex(0);
              }
            },
            (error) => {
              showToast("error", "Upload Failed!");
              setUploading(false);
              setVideoIndex(0);
            }
          );
        }
      },
      (error) => {
        showToast("error completeMultipartUpload!", error);
      }
    );
  }

  useEffect(() => {
    if (
      fileSize > 0 &&
      uploadId != "" &&
      fileToBeUpload != null &&
      chunkCount > 0 &&
      fileName != ""
    ) {
      const fn = async () => {
        await generatePresignedUrlsParts();
      };

      fn().catch(console.error);
    }
  }, [uploadId, fileToBeUpload, chunkCount, fileName]);

  useEffect(() => {
    console.log("urls", urls);
    if (Object.keys(urls).length > 0) {
      const fn = async () => {
        await uploadParts();
      };

      fn().catch(console.error);
    }
  }, [urls]);

  useEffect(() => {
    if (parts.length > 0) {
      const fn = async () => {
        await completeMultiUpload();
      };

      fn().catch(console.error);
    }
  }, [parts]);

  // ! ==============================================================

  const resetChunkProperties = () => {
    setUploadId("");
    setFileName("");
    setFileToBeUpload({});
    setProgress([]);
    setFileSize(0);
    setUrls([]);
    setParts([]);
    setChunkCount(0);
  };

  const getFileContext = (_file) => {
    resetChunkProperties();
    setFileSize(_file.size);
    const _totalCount =
      _file.size % FILE_CHUNK_SIZE == 0
        ? _file.size / FILE_CHUNK_SIZE
        : Math.floor(_file.size / FILE_CHUNK_SIZE) + 1;
    setChunkCount(_totalCount);
    setFileToBeUpload(_file);
  };

  const onFilesSelect = (event) => {
    if (uploading) {
      showToast("error", "Already uploading!");
      return;
    }
    files = event.target.files;
    console.log("files: " + files.length);
    setVideosCount(files.length);
    setVideoIndex(index);
    uploadVideo(index);
  };

  const uploadVideo = (index) => {
    if (index < files.length) {
      console.log("uploadVideo");
      setUploading(true);
      let file = files[index];

      let fileUrl = URL.createObjectURL(files[index]);
      let fileName = files[index].name.split(".")[0];
      // generate thumbnail
      setVideoUrl("");
      setTimeout(() => {
        console.log("fileUrl: " + fileUrl);
        setVideoUrl(fileUrl);
        setTimeout(() => {
          const frame = captureVideoFrame("my-video", "jpeg");
          // console.log("frame: " + JSON.stringify(frame));
          const img = document.getElementById("my-screenshot");
          img.setAttribute("src", frame.dataUri);
          fetch(frame.dataUri)
            .then((res) => res.blob())
            .then((blob) => {
              console.log("thumbnail: " + blob);
              setThumbnail(blob);
              // upload video now
              setTimeout(async () => {
                console.log("fileName: " + fileName);
                console.log("fileUrl: " + fileUrl);
                console.log("===>", model, guide);

                //! HERE
                let extension = getFileExtension(file.name);
                const _fileName =
                  uuidv4() +
                  "_" +
                  file.name
                    .replaceAll(" ", "_")
                    .replaceAll(extension, extension.toLowerCase());
                extension = extension.toLowerCase();

                getFileContext(file);
                setFileName(_fileName);

                console.log("_fileName", _fileName);

                initiateMultipartUpload(_fileName);
              }, 1000);
            });
        }, 2000);
      }, 50);
    } else {
      console.log("no more videos to upload");
      setUploading(false);
      setVideoIndex(0);
      showToast("success", "All videos uploaded");
    }
  };

  const randomFixedNumber = (length) => {
    return Math.floor(
      Math.pow(10, length - 1) +
        Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)
    );
  };

  function getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }

  const showSelectedVideos = () => {
    let videos = "";
    for (let i = 0; i < selectedVideos.length; i++) {
      const vid = selectedVideos[i];
      if (i < selectedVideos.length - 1) videos = videos + vid.title + ",";
      else videos = videos + vid.title;
    }
    if (videos === "") return "Choose Video(s)";
    return videos;
  };

  const uploadSelectedVideos = (videos) => {
    setLoader(true);
    Api.addOtherCategoryVideos(
      library_type,
      model.id,
      JSON.stringify(videos),
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Videos Added!");
        }
      },
      (error) => {
        setLoader(false);
        showToast("error", "" + error);
      }
    );
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>Upload Videos</div>
      </div>
      <div style={{ marginTop: 20 }}>
        <img
          onClick={() => {
            console.log("click");
            history.goBack();
          }}
          src={back}
          style={{ width: 30, height: 30, marginTop: 10, marginRight: 10 }}
          className="icon-btn"
        />
        <div style={{ display: "flex", marginTop: 10 }}>
          <Button
            className="btn-block btn-submit"
            style={{ width: 150, borderWidth: 0, fontSize: 16 }}
            onClick={() => {
              console.log("click");
              addFile.current.click();
            }}
          >
            Choose Videos
          </Button>

          {model == null && (guide || settings_pro) ? null : (
            <CustomPicker
              library_type={library_type}
              type="video"
              title={"Select Videos"}
              selectedVideos={selectedVideos}
              onDone={(videos) => {
                console.log("selected: " + JSON.stringify(videos));
                setSelectedVideos(videos);
                uploadSelectedVideos(videos);
              }}
              button={
                <Button
                  className="btn-block btn-submit"
                  style={{
                    width: 250,
                    borderWidth: 0,
                    marginLeft: 15,
                    fontSize: 16,
                  }}
                  onClick={() => {
                    console.log("click");
                    showSelectedVideos();
                  }}
                >
                  Choose from Other Category
                </Button>
              }
            />
          )}

          {/* <Button
                        className='btn-block btn-submit'
                        style={{ width: 250, borderWidth: 0, marginLeft: 15 }}
                        onClick={() => {
                            console.log('click');

                        }}>
                        Choose from Other Category
                    </Button> */}
        </div>

        <input
          type="file"
          multiple="multiple"
          style={{ display: "none" }}
          ref={addFile}
          onChange={(event) => {
            onFilesSelect(event);
          }}
        />

        {videoUrl == "" ? null : (
          <div style={{ marginTop: 20 }}>
            <video
              id="my-video"
              autoPlay
              width="300"
              height="200"
              controls
              hidden
            >
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        {videoUrl == "" ? null : (
          <img
            id="my-screenshot"
            style={{
              width: 300,
              height: 200,
              objectFit: "contain",
              backgroundColor: "lightgray",
            }}
          />
        )}
        {uploading ? (
          <div style={{ marginTop: 10, color: "green" }}>
            Uploading... {index + 1}/{videosCount}
            <Progress value={(progress.length * 100) / chunkCount} />
          </div>
        ) : null}
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default UploadVideos;
